import styled, { css } from 'styled-components';

import CoreButtonGroup from '@ovpn/ui/buttons-group';

import { boxed } from '@sso/shared/hocs';

const ButtonGroup = styled(CoreButtonGroup)`
    ${t =>
        t.fullWidth &&
        css`
            flex-wrap: wrap;
            width: 100%;

            & > * {
                flex: 1;

                white-space: nowrap;
            }
    `}
`;

export default boxed(ButtonGroup);
